<div class="setting-page setting-page-full-width">
  <legend>Routing Servers</legend>
  <div class="header-container" >
  <div class="search-container">
    <client-filter (onFilter)="onFilter($event)"></client-filter>
  </div>
  <div class="action-buttons">
    <arm-action-bar (addClick)="addEditItem(false)" [disableAdd]="isUnauthorized"
                    (deleteClick)="removeItem()" [disableDelete]="!selection || isUnauthorized"
                    (editClick)="addEditItem(true)" [disableEdit]="!selection || isUnauthorized"
                    (refreshClick)="refresh()"></arm-action-bar>
    <button [matMenuTriggerFor]="menu" class="settings-more-actions" color="primary" mat-raised-button>
      <span>Actions</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button (click)="lock()" [disabled]="isUnauthorized ||
                (this.selection && this.selection?.adminState === 'LOCKED')" mat-menu-item>
        <span>Lock</span>
      </button>
      <button (click)="unlock()" [disabled]="isUnauthorized ||
                (this.selection && this.selection?.adminState === 'UNLOCKED')" mat-menu-item>
        <span>Unlock</span>
      </button>
      <button (click)="certificate()" [disabled]="isUnauthorized"  mat-menu-item>
        <span>Certificate</span>
      </button>
    </mat-menu>


  </div>

  </div>


  <div class="settings-general-table">
    <arm-table [displayedColumns]="displayedColumns"
               (onSelection)="onSelection($event)" [data]="items"
               [isMultipleSelection]="false"
               [isClientSide]="true" [isPagedTable]="true" [filter]="filter"></arm-table>
  </div>
</div>
